import type { PackagePlan } from '../types'

export const packages: PackagePlan[] = [
  {
    id: 'esencial',
    name: 'Esencial',
    price: '$600',
    priceNote: 'único',
    delivery: 'Entrega en 7 días',
    tone: 'blue',
    popular: false,
    features: [
      'Página web profesional personalizada',
      'Optimizada para celular y tablet',
      'Ficha de Google My Business',
      'Formulario de contacto',
      'Hasta 5 secciones',
      '1 revisión incluida',
    ],
  },
  {
    id: 'pro',
    name: 'Pro',
    price: '$1,200',
    priceNote: 'único',
    delivery: 'Entrega en 7 días',
    tone: 'yellow',
    popular: true,
    features: [
      'Todo lo del paquete Esencial',
      'CRM integrado para leads',
      'Agenda automática online',
      'Recordatorios por WhatsApp',
      'Hasta 10 secciones',
      '3 revisiones incluidas',
    ],
  },
  {
    id: 'elite',
    name: 'Elite',
    price: '$1,800',
    priceNote: 'único',
    delivery: 'Entrega en 7 días',
    tone: 'green',
    popular: false,
    features: [
      'Todo lo del paquete Pro',
      'Blog o tienda básica',
      'SEO avanzado local',
      'Chat de WhatsApp en la web',
      'Secciones ilimitadas',
      'Soporte 30 días incluido',
    ],
  },
]
